export const normalizeForQueryParams = (data) => {
  return {
    zipcode: data.zip,
    State: data.state,
    creditscore: normalizeCreditscore(data.creditscore),
    propertyvalue: data.propertyvalue,
    PropertyType: normalizePropertyType(data.propertytype),
    HomeListed: normalizeHomeListed(data.realtorlisting),
    SellTimeFrame: normalizeTimeframe(data.timeframe),
    SourceID: data.publisher_id ?? 10000,
    ExtClickID: window.leadId || '',
    HardshipReason: normalizeHardship(data.reasonforselling)
  };
};

const normalizePropertyType = (value) => {
  const map = {
    'single family': 'Single Family',
    'condominium': 'Condo/Townhome',
    'townhome': 'Condo/Townhome',
    'mobile or manufactured home': 'Mobile',
  };
  return map[value] || 'Other';
};

const normalizeHomeListed = (value) => {
  return value === 'yes' ? 'Yes' : 'No';
};

const normalizeTimeframe = (value) => {
  const map = {
    'asap': 'Now',
    '2 to 3 months': '3_Months',
    '6 months': '6_Months',
    'im in no rush': '1_Year',
  };
  return map[value] || 'Unknown';
};

const normalizeHardship = (value) => {
  const map = {
    'behind on mortgage payments': 'Behind on mortgage',
    'job income loss': 'Job/income loss',
    'need to access cash': 'Need to access cash',
    'property needs repairs': 'Property Needs Repairs',
    'downsizing relocating': 'Downsizing/Relocating',
    'curious to see house value': 'Research Home Metrics',
  };
  return map[value] || 'Other';
};

const normalizeCreditscore = (value) => {
  const map = {
    'excellent': 'Excellent',
    'good': 'Good',
    'fair': 'Fair',
    'poor': 'Poor',
  };
  return map[value] || 'Unknown';
};